import { render } from "./SelectPriceTypeView.vue?vue&type=template&id=109c213a&scoped=true&ts=true"
import script from "./SelectPriceTypeView.vue?vue&type=script&lang=ts"
export * from "./SelectPriceTypeView.vue?vue&type=script&lang=ts"

import "./SelectPriceTypeView.vue?vue&type=style&index=0&id=109c213a&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution.Cashier/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-109c213a"]])

export default __exports__